import { WidgetType, WidgetHeaderType, WidgetFooterType } from '../widget.types';
import { Resource } from '@topconagriculture/permissions';
export const MapWidgetConfig = {
    type: WidgetType.MAP,
    single: true,
    thumbnail: '/assets/images/dashboard/widget-catalog/map.jpg',
    title: 'widget:map:title',
    description: 'widget:map:description',
    permissions: [Resource.FIELDS],
    header: {
        type: WidgetHeaderType.GENERIC,
    },
    footer: (config) => ({
        type: WidgetFooterType.VIEW_MORE,
        href: config.MAP_VIEW_MORE_LINK,
        text: 'widget:generic:footer_text',
    }),
    baseConfig: {
        type: WidgetType.MAP,
        w: 2,
        h: 4,
        x: 0,
        y: 0,
    },
};
//# sourceMappingURL=MapWidgetConfig.js.map